export function getExtraBookingTermsUrl(booking) {
  const week = booking && booking.week;
  if (!week) {
    return undefined;
  }

  const extraTermsUrl = week.extraTermsUrl || (week.parentWeek && week.parentWeek.extraTermsUrl);
  if (!extraTermsUrl) {
    return undefined;
  }

  const weekId = (week.parentWeek && week.parentWeek.id) || week.id;
  return `/extra-booking-terms?weekId=${weekId}`;
}
